module.exports = __webpack_public_path__ + "img/puzzle.9c88f143.svg";